import React from "react";

import { useNavigate } from "react-router-dom";

import { useGetAllBlogsQuery } from "../../store/General/generalSlice";

export default function GrowWithNeurogen() {
  const navigate = useNavigate();
  const {
    data: allBlogs,
    isSuccess,
    isLoading,
    isError,
    error,
  } = useGetAllBlogsQuery();
  return (
    <>
      <div className="portfolioblog">
        <h2 className="h2headerportfolio">Grow With NeuroGen</h2>
        <p>
          At NeuroGen Healthcare, we pioneer the future of medicine. From
          AI-powered organ transplantation to personalized anti-cancer
          treatments, we’re revolutionizing healthcare.
        </p>

        <div className="portfolioblogrow">
          {allBlogs &&
            allBlogs?.blogs?.map((blog) => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(blog.content, "text/html");
              const firstImage = doc.querySelector("img")?.src || "";
              return (
                <div
                  onClick={() => {
                    navigate(`/blog/${blog.slug}`);
                  }}
                  className="portfolioblogcard statsquarediv gradientdiv"
                >
                  <img src={firstImage} alt="" />
                  <p>{blog.title}</p>
                  <p className="statspreview">
                    Read More
                    <ion-icon name="chevron-forward-outline"></ion-icon>
                  </p>
                </div>
              );
            })}
          {/* <div className="portfolioblogcard statsquarediv gradientdiv">
            <img src={bottomleftone} alt="" />
            <div className="statssquaredivcontent">
              <p>Webflow Speed Optimisation Checklist</p>
              <p className="statspreview">
                Read More<ion-icon name="chevron-forward-outline"></ion-icon>
              </p>
            </div>
          </div>
          <div className="portfolioblogcard statsquarediv gradientdiv">
            {" "}
            <img src={bottomleftone} alt="" />
            <div className="statssquaredivcontent">
              <p>Webflow Speed Optimisation Checklist</p>
              <p className="statspreview">
                Read More<ion-icon name="chevron-forward-outline"></ion-icon>
              </p>
            </div>
          </div>
          <div className="portfolioblogcard statsquarediv gradientdiv">
            {" "}
            <img src={bottomleftone} alt="" />
            <div className="statssquaredivcontent">
              <p>Webflow Speed Optimisation Checklist</p>
              <p className="statspreview">
                Read More<ion-icon name="chevron-forward-outline"></ion-icon>
              </p>
            </div>
          </div> */}
        </div>
      </div>
      <p className="portfoliosubline">
        Looking for more?{" "}
        <a onClick={() => navigate("/blog-home")}>See all resources</a>
      </p>
    </>
  );
}
